import React from 'react';
import { Grid } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import {
	DetailsSectionDescription,
	DetailsSectionFiles,
	DetailsSectionImage,
	DetailsSectionInfoWrapper,
	type DetailsPageContentProps
} from 'app/main/components/page-layouts';

import DocumentsDetailsSectionInfo from '../sections/DocumentsDetailsSectionInfo';

export default function DocumentDetailsTab(props: DetailsPageContentProps) {
	const { sysSettings, t } = useSettings();

	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 8, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_INFO_SECTION')}
							subheader={t('DETAILS_INFO_SUBHEADER')}
						>
							<DocumentsDetailsSectionInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionDescription
							name="fold_descriptionhtml"
							value={props.model.fold_descriptionhtml}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
					{!props.isAdd && !props.model.fold_personal && !!props.model.fold_foldername && (
						<Grid size={12}>
							<DetailsSectionFiles
								icon={<Icon icon="folder-outline" />}
								title={t('DETAILS_DOCUMENTS_FOLDERS_CONTENT_SECTION')}
								subheader={t('DETAILS_DOCUMENTS_FOLDERS_CONTENT_SECTION_SUBHEADER')}
								folderPath={`${sysSettings.docs_path}${props.model.fold_foldername}`}
							/>
						</Grid>
					)}
				</Grid>
			</Grid>
			<Grid size={{ lg: 4, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionImage
							title={t('DETAILS_THUMBNAIL_SECTION')}
							subheader={t('DETAILS_THUMBNAIL_SUBHEADER')}
							isEdit={props.isEdit}
							fieldName="fold_image"
							fileName={props.model.fold_uid?.toUpperCase()}
							path="documents-folders/thumbnails"
							value={props.model.fold_image}
							sendChange={props.sendFilesChange}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}
